<template>
  <div id="" class="mainDiv">
    <div v-if="userInfo" class="top">
      <div class="top-li">
        <div class="top-li-left">
          <img v-if="userInfo" :src="url + userInfo.userPhoto" alt="" />
        </div>
        <div class="top-li-right">
          <p style="font-size: 18px">{{ userInfo.fullName }}</p>
          <p>准考证号：{{ userInfo.admissionCard }}</p>
          <p>身份证号：{{ userInfo.userCard }}</p>
          <p>登记手机号：{{ userInfo.phone }}</p>
        </div>
      </div>
      <div class="top-li">
        <div class="top-li-2">
          <p style="font-size: 18px; font-weight: 600">{{ userInfo.score }}</p>
          <p class="gray-txt">本次考试得分</p>
        </div>
      </div>
      <div class="top-li">
        <div class="top-li-2">
          <p class="yellow-txt" style="font-size: 18px; font-weight: 600">
            <span v-if="userInfo.status == 0">待审核</span>
            <span v-else-if="userInfo.status == 1">成绩有效</span>
            <span v-else-if="userInfo.status == 2">成绩无效</span>
          </p>
          <p class="gray-txt">本次考试结果</p>
        </div>
      </div>
      <div class="top-li">
        <div class="top-li-2">
          <p class="gray-txt" style="font-size: 18px; font-weight: 600">
            <span v-if="userInfo.tourStatus == 0">未巡考</span>
            <span v-else-if="userInfo.tourStatus == 1">已通过</span>
            <span v-else-if="userInfo.tourStatus == 2">未通过</span>
          </p>
          <p class="gray-txt">巡考状态</p>
        </div>
      </div>
      <div class="top-li">
        <div class="top-li-2">
          <p
            class="yellow-txt"
            style="font-size: 14px; font-weight: 600; padding: 0"
          >
            <span v-if="userInfo.faceScreenShotDiscriminateRate > 70"
              >验证通过</span
            >
            <span v-else>识别率过低</span>
          </p>
          <p
            class="yellow-txt"
            style="font-size: 14px; font-weight: 600; padding: 0"
          >
            （识别率{{ userInfo.faceScreenShotDiscriminateRate }}%）
          </p>
          <p class="gray-txt">本次人脸抓拍验证</p>
        </div>
      </div>
      
    </div>
    <p class="title">人脸抓拍验证记录</p>
    <div class="record-info">
      <div class="record-info-left">
        当前已抓拍{{
          screenShotList.length
        }}张考生考试过程中的人脸照片，识别通过{{ passCount }}张，不通过<span
          style="color: red"
          >{{ screenShotList.length - passCount }}</span
        >张
      </div>
      <div class="record-info-right">
        要求识别率：70%/当前识别率：<span style="color: red"
          >{{ userInfo.faceScreenShotDiscriminateRate }}%</span
        >
      </div>
    </div>
    <div class="record-list">
      <p style="padding: 5px">识别通过（{{ passCount }}）</p>
      <div class="record-img-ul">
        <div
          v-for="(item, index) in screenShotList"
          :key="index"
          class="record-img-li"
        >
          <div class="record-img-li-lv">
            识别率：{{ item.discriminateRate }}%
          </div>
          <img :src="url + item.fileName" alt="" />
          <div class="record-img-li-bottom">
            <div v-if="item.status == 0">正常</div>
            <div v-if="item.status == 1">异常</div>
            <div>{{ item.createTime | showDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <p class="title">视频巡考验证记录</p>
    <div class="xunkao-record">
      <div v-if="captureList.length > 0" class="record-img-ul">
        <div
          v-for="(item, index) in captureList"
          :key="index"
          class="record-img-li"
        >
          <div class="record-img-li-lv">
            识别率：{{ item.discriminateRate }}%
          </div>
          <img :src="url + item.fileName" alt="" />
          <div class="record-img-li-bottom">
            <div v-if="item.status == 0">正常</div>
            <div v-if="item.status == 1">异常</div>
            <div>{{ item.createTime | showDate }}</div>
          </div>
        </div>
      </div>
      <div v-else class="videp-record gray-txt">暂无视频巡考验证记录</div>
    </div>
    <p class="title">最终审核记录</p>
    <el-table
      ref="multipleTable"
      :data="tableData2"
      class="auditRecord"
      border
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
    >
      <el-table-column type="id" v-if="false"></el-table-column>
      <el-table-column prop="auditTime" label="记录时间">
        <template slot-scope="scope">
          {{ (scope.row.auditRecord.auditTime * 1000) | datetimeFormat }}
        </template>
      </el-table-column>
      <el-table-column prop="auditType" label="审核方式">
        <template slot-scope="scope">
          <span v-if="scope.row.auditRecord.auditType == 0">系统审核</span>
          <span v-if="scope.row.auditRecord.auditType == 1">人工审核</span>
        </template>
      </el-table-column>
      <el-table-column prop="uname" label="审核人">
           <template slot-scope="scope" v-if="scope.row.auditRecord">
              {{ scope.row.auditRecord.uname }}
          </template>
      </el-table-column>
      <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditRecord.auditStatus == 0">未通过</span>
          <span v-if="scope.row.auditRecord.auditStatus == 1">已通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="不通过原因">
        <template slot-scope="scope">
          {{ scope.row.auditRecord.reason }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="auditTime" label="不通过时间">
        <template
          slot-scope="scope"
          v-if="scope.row.auditRecord.auditStatus === 0"
        >
          {{ (scope.row.auditRecord.auditTime * 1000) | datetimeFormat }}
        </template>
      </el-table-column> -->
      <el-table-column prop="reason" label="考试过程截图">
        <template slot-scope="scope" v-if="scope.row.screenShots.length > 0">
          <el-image
            style="width: 100px"
            :src="url + scope.row.screenShots[0].fileName"
            :preview-src-list="scope.row.srcList"
          >
          </el-image>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottom-btn">
      <el-button type="success" @click="auditPass">审核通过</el-button>
      <el-button type="warning" @click="showNopassDialog = true"
        >审核不通过</el-button
      >
    </div>

    <el-dialog
      title="审核不通过"
      :visible.sync="showNopassDialog"
      :before-close="beforeCloseStopExamDialog"
      destroy-on-close
    >
      <el-form>
        <el-form-item v-if="userInfo" label="学生姓名" :label-width="'120px'">
          <p>{{ userInfo.fullName }}</p>
        </el-form-item>
        <el-form-item v-if="userInfo" label="准考证号" :label-width="'120px'">
          <p>{{ userInfo.admissionCard }}</p>
        </el-form-item>
        <el-form-item v-if="userInfo" label="身份证号" :label-width="'120px'">
          <p>{{ userInfo.userCard }}</p>
        </el-form-item>
        <el-form-item label="原因" :label-width="'120px'">
          <el-input
            v-model="stopReason"
            type="textarea"
            autocomplete="off"
            placeholder="请仔细填写取消考试的原因"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择过程性截图" :label-width="'120px'">
          <el-button type="primary" @click="showSelectImage = true"
            >从考试过程截图中选择</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showNopassDialog = false">取 消</el-button>
        <el-button type="primary" @click="auditFailed">确 定</el-button>
      </div>

      <el-dialog
        width="100%"
        title="选择过程性截图"
        :visible.sync="showSelectImage"
        append-to-body
      >
        <div class="record-info">
          <div class="record-info-left">
            当前已抓拍{{
              screenShotList.length
            }}张考生考试过程中的人脸照片，识别通过{{ passCount }}张，不通过<span
              style="color: red"
              >{{ screenShotList.length - passCount }}</span
            >张
          </div>
          <div class="record-info-right">
            要求识别率：70%/当前识别率：<span style="color: red"
              >{{ userInfo.faceScreenShotDiscriminateRate }}%</span
            >
          </div>
        </div>
        <div class="record-list">
          <p style="padding: 5px">识别通过（{{ passCount }}）</p>
          <div class="record-img-ul">
            <div
              v-for="(item, index) in screenShotList" :key="index"
              class="record-img-li"
              @click="selectProgressImage(item.id)"
            >
              <div class="record-img-li-lv">
                识别率：{{ item.discriminateRate }}%
              </div>
              <img :src="url + item.fileName" alt="" />
              <div class="record-img-li-bottom">
                <div v-if="item.status == 0">正常</div>
                <div v-if="item.status == 1">异常</div>
                <div>{{ item.createTime | showDate }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>

     <div style="position: absolute; right: 42px; top: 90px">
        <el-button type="info" @click="back"> 返回 </el-button>
      </div>
  </div>
</template>

<script>
import * as api from '@/api/invigilate/invigilateList'
import * as api2 from '@/api/exam/exam'
import { formatDate, setHost } from '@/utils/common'

export default {
  name: 'InvigilateExamine',
  data() {
    return {
      tableData2: [],
      showNopassDialog: false,
      showSelectImage: false,
      userInfo: [],
      stopReason: '',
      stopReasonImg: '',
      screenShotList: [],
      host: '',
      passCount: '',
      captureList: [],
      srcList: [],
      vid:''
    }
  },
  filters: {
    // 时间格式化
    showDate(value) {
      let date = new Date(value * 1000)
      return formatDate(date, 'mm:ss')
    },
  },
  computed: {
    passRate: function () {
      const passCount = this.passCount
      const allCount = Number(this.screenShotList.length)
      if (passCount === 0 || allCount === 0) return 0
      const rate = (passCount / allCount).toFixed(4) * 100
      return rate
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }else if(window.location.host == 'http://gz.hnjk.net'){
        url = 'http://gz.hnjk.net'
      }else{
        url = 'https://fxl.sce.scut.edu.cn' + '/zk'
      }
      return url
    },
  },
  methods: {
    // 获取考生信息
    getExamsUsersById() {
      // console.log("1213345",url())
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
      }
      api2.getExamsUsersById(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          // data.data.userPhoto = this.url() +  data.data.userPhoto
          console.log("1213345",data.data)
          that.userInfo = data.data
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 获取考试过程性截图
    getScreenShotList() {
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
        type: 0,
        staus: '',
      }
      api.getScreenShotList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.screenShotList = data.data
          let passCount = 0
          //计算通过抓拍的张数
          for (let item of data.data) {
            if (item.status == 0) {
              passCount++
            }
          }
          that.passCount = passCount
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 获取抓拍截图
    getScreenShotList2() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
        type: 1,
        staus: '',
      }
      api.getScreenShotList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.captureList = data.data
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 获取最终审核记录
    getAuditRecordList() {
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
      }
      api.getAuditRecordList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          data.data.forEach((item) => {
            if (item.screenShots.length > 0) {
              item.srcList = [this.url + item.screenShots[0].fileName]
            }
            item.auditRecord.uname =  localStorage.getItem('uname')
          })
          this.tableData2 =  data.data
          console.log(this.tableData2)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    beforeCloseStopExamDialog() {
      this.stopReason = ''
      this.stopReasonImg = ''
      this.showNopassDialog = false
    },
    // 在终止考试弹窗里选择过程截图
    selectProgressImage(id) {
      console.log(id)
      this.stopReasonImg = id
      this.$message.success('选择成功')
      this.showSelectImage = false
    },
    // 审核通过
    auditPass() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
      }
      api.auditPass(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.$message.success(data.msg)
          this.getAuditRecordList()
          // window.history.go(-1)
        } else {
          this.$message.error(data.msg)
        }
      })
      // 审核查重
      // let repeatdata = {
      //   examsPaperId: this.examsPaperId,
      //   batchId: this.batchId,
      // }
      // api.repeatThan(repeatdata).then(({ data }) => {
      //   console.log(data);
      // })
    },
    auditFailed() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
        reason: this.stopReason,
        screenShotIds: this.stopReasonImg,
      }
      api.auditFailed(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.$message({ message: '操作成功', type: 'success' })
          this.showNopassDialog = false
          this.getAuditRecordList()
          // window.history.go(-1)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    back() {
      this.$router.go(-1)
      // this.$router.push(`/ExamArrangementDetail?tab=4&batchId=${this.batchId}&uid=${localStorage.getItem('uid')}&courseName=${this.courseName}&examsPaperId=${this.examsPaperId}&examsPaperTitle=${this.examsPaperTitle}&vid=${this.vid}`)
    },
    //考试过程截图
    // showAuditImg(id) {
    //   api.getScreenShotListById({ id }).then((res) => {
    //     console.log(res)
    //   })
    // },
    goBack() {
      window.history.go(-1)
    },
  },
  mounted() {
    this.examsUsersId = this.$route.query.exams_users_id
    this.examsPaperId = this.$route.query.examsPaperId
    this.examinerId = this.$route.query.examiner_id
    this.vid = this.$route.query.vid
    this.batchId = this.$route.query.batchId
    this.courseName = this.$route.query.courseName
    this.examsPaperTitle = this.$route.query.examsPaperTitle
    console.log("laodiu1", localStorage.getItem('uname'));
    this.host = setHost()
    this.getExamsUsersById()
    this.getScreenShotList()
    this.getScreenShotList2()
    this.getAuditRecordList()
  },
}
</script>

<style lang="scss" scoped>
.mainDiv {
  margin: 0;
}
.top {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #f6f6f6;
  padding: 10px 0;
}
.title {
  padding: 10px 0;
}
.top-li {
  display: flex;
  align-items: center;
  border-right: 2px solid #f6f6f6;
  padding: 20px;
  height: 140px;
}
.top-li-left {
  margin-right: 10px;
  height: 100px;
}
.top-li-left > img {
  width: 97px;
  height: 115px;
}
.top-li-right {
  height: 100px;
}
.top-li-2 > p {
  text-align: center;
  padding: 3px 0;
}
.gray-txt {
  color: #b2ada7;
  font-size: 12px;
}
.yellow-txt {
  color: #ff8e3c;
}
.record-list {
  border: 2px solid #f6f6f6;
  padding-bottom: 10px;
}
.record-info {
  display: flex;
  justify-content: space-between;
  border: 2px solid #f6f6f6;
  padding: 10px;
  font-size: 14px;
}
.record-img-ul {
  display: flex;
  flex-wrap: wrap;
}
.record-img-li {
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}
.record-img-li-lv {
  position: absolute;
  top: 5px;
  right: 0px;
  font-size: 12px;
  color: white;
  padding: 3px;
  background-color: rgba(30, 30, 30, 0.7);
}
.record-img-li > img {
  width: 120px;
  height: 90px;
}
.record-img-li-bottom {
  display: flex;
  justify-content: space-between;
  background-color: #58b65a;
  color: white;
  font-size: 12px;
  padding: 5px;
}
.videp-record {
  border: 2px solid #f6f6f6;
  padding: 10px;
  text-align: center;
}
.bottom-btn {
  text-align: center;
  padding-top: 20px;
}
.xunkao-record {
  border: 2px solid #f6f6f6;
  padding: 10px 0;
}
</style>
